<template>
  <div style="background-color: #fff">
    <Header position="sticky" :isHome="false"></Header>
    <Banner></Banner>
    <div
      class="df"
      :class="{ fdc: isMobile }"
      style="margin-bottom: 1rem; cursor: pointer"
    >
      <div
        :style="`width:${isMobile ? '100%' : '50%'}`"
        class="por"
        @click="router('productCustomize')"
      >
        <img style="height: auto" src="../../assets/imgs/left.png" alt="" />
        <span
          class="poa text-white"
          :style="
            isMobile
              ? 'left: 1.5rem;top: 1rem;font-size: 0.7rem;'
              : 'left: 3rem;top: 1.9rem;font-size: 1.2rem;'
          "
        >
          Didn't find the right product?
        </span>
        <span
          class="poa text-white"
          :style="
            isMobile
              ? 'left: 1.5rem;top: 2rem;font-size: 1rem;font-weight: bold;'
              : 'left: 3rem;top: 3.1rem;font-size: 1.9rem;font-weight: bold;'
          "
        >
          Customize your demands now
        </span>
        <span
          class="poa bg-white font-weight-bold"
          :style="
            isMobile
              ? 'left: 1.5rem;top: 3.7rem;font-size: 0.5rem;display: inline-block;padding: 5px 15px;color: #37a9f0;border-radius: 30px;'
              : 'left: 3rem;top: 6.5rem;font-size: 1rem;display: inline-block;padding: 10px 25px;color: #37a9f0;border-radius: 30px;'
          "
        >
          Go Customize
        </span>
      </div>
      <div
        :style="`width:${isMobile ? '100%' : '50%'}`"
        class="por"
        @click="router('customizeList')"
      >
        <img style="height: auto" src="../../assets/imgs/right.png" alt="" />
        <span
          class="poa text-white"
          :style="
            isMobile
              ? 'left: 1.5rem;top: 1.8rem;font-size: 1rem;font-weight: bold;'
              : 'left: 2.8rem;top: 3rem;font-size: 1.9rem;font-weight: bold;'
          "
        >
          See customer customization
        </span>
        <span
          class="poa bg-white font-weight-bold"
          :style="
            isMobile
              ? 'left: 1.5rem;top: 3.5rem;font-size: 0.5rem;display: inline-block;padding: 5px 15px;color: #46d6bd;border-radius: 30px;'
              : 'left: 2.6rem;top: 6.5rem;font-size: 1rem;display: inline-block;padding: 10px 20px;color: #46d6bd;border-radius: 30px;'
          "
        >
          Go view
        </span>
      </div>
    </div>

    <div class="container new-container" v-if="data">
      <div
        class="row main-box"
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 15px;
          padding-right: 15px;
          flex-direction: row;
        "
      >
        <div style="font-size: 1rem; color: #000; font-weight: 500">
          <span
            class="hover-light"
            style="cursor: pointer; margin-right: 0.5rem"
            @click="$router.push({ name: 'home' })"
            >Home</span
          >>
          <span style="margin-left: 0.5rem">Selection Hub</span>
        </div>

        <!-- 搜索框 -->
        <div class="box1" style="display: flex">
          <div style="" class="search-box" @keydown.enter="getdata()">
            <input
              type="text"
              style="
                border: none;
                background-color: transparent;
                color: #000;
                font-size: 1rem;
                width: 100%;
              "
              v-model="params.keyword"
              placeholder="Search"
            />
            <img
              src="../../assets/imgs/search-dark.png"
              style="width: 1rem; height: 1rem"
              @click="getdata()"
            />
          </div>
          <!-- 筛选按钮 -->
          <div
            v-if="isMobile"
            style="margin-left: 3rem"
            class="filter-box"
            @click="showFilter = !showFilter"
          >
            <span
              :style="`${isMobile ? 'font-size:0.9rem;' : null}`"
              style="white-space: nowrap"
              >Filter by</span
            >
            <img
              :style="`${
                isMobile
                  ? 'margin-left:0.3rem;width: 0.8rem;height: 0.8rem;'
                  : 'margin-left:1rem;width: 1rem;height: 1rem;'
              };`"
              src="../../assets/imgs/filter.png"
              style=""
            />
          </div>
        </div>
      </div>
      <div class="flex-wrap">
        <div class="pro-list-left">
          <!-- pc左侧筛选 -->
          <!-- <LeftFilter :categories="categories"></LeftFilter> -->
          <div class="wrap" v-if="!isMobile">
            <div :style="`width: ${isMobile ? 210 : 100}% !important;`">
              <div
                slot="title"
                style="font-weight: bold; font-size: 1.5rem; color: #000"
                class="wrap-pdr05"
              >
                Filter by
              </div>
              <div
                class="df fdc wrap-pdr05"
                style="height: 77vh; overflow-y: scroll; overflow-x: hidden"
              >
                <div
                  style="
                    margin: 0;
                    border-top: 1px solid #dddddd;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.2rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div class="side-title" style="cursor: pointer">
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        class="nwp"
                        >Recommended products</span
                      >
                      <el-checkbox
                        @change="getdata"
                        true-label="true"
                        false-label=""
                        style="
                          margin-top: 0.5rem;
                          width: 100%;
                          text-align: right;
                          padding-right: 0.5rem;
                        "
                        v-model="params.recommendedProducts"
                        label=""
                      ></el-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.2rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div class="side-title" style="cursor: pointer">
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        class="nwp"
                        >Selected Products</span
                      >
                      <el-checkbox
                        @change="getdata"
                        true-label="true"
                        false-label=""
                        style="
                          margin-top: 0.5rem;
                          width: 100%;
                          text-align: right;
                          padding-right: 0.5rem;
                        "
                        v-model="params.selectedProducts"
                        label=""
                      ></el-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.2rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div class="side-title" style="cursor: pointer">
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        class="nwp"
                        >New Products</span
                      >
                      <el-checkbox
                        @change="getdata"
                        true-label="true"
                        false-label=""
                        style="
                          margin-top: 0.5rem;
                          width: 100%;
                          text-align: right;
                          padding-right: 0.5rem;
                        "
                        v-model="params.newProducts"
                        label=""
                      ></el-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.7rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div
                      class="side-title"
                      @click="typeFilter = !typeFilter"
                      style="cursor: pointer"
                    >
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        >Type</span
                      >
                      <img
                        src="../../assets/imgs/arrow-down-black.png"
                        class="transition-normal"
                        style="
                          width: 0.8rem;
                          height: 0.4rem;
                          margin-right: 1rem;
                        "
                        :style="{
                          transform: typeFilter ? 'rotate(180deg)' : 'none',
                        }"
                      />
                    </div>
                    <el-collapse-transition>
                      <div
                        class="side-content"
                        style="margin-top: 1rem"
                        v-show="typeFilter && showcategoryFilter"
                      >
                        <template
                          v-for="(item, index) in categories"
                          v-if="showType"
                        >
                          <div class="df jcsb aic wm">
                            <el-checkbox
                              :indeterminate="isIndeterminate"
                              :key="index"
                              v-model="category[item.id]"
                              @change="
                                handleCheckAllChange($event, item.id, index)
                              "
                              >{{ item.name }}</el-checkbox
                            >
                            <img
                              @click="changeCategory(item.id)"
                              v-if="item.children && item.children.length"
                              src="../../assets/imgs/arrow-down-black.png"
                              class="transition-normal"
                              style="
                                width: 0.8rem;
                                height: 0.4rem;
                                margin-left: 0.5rem;
                                margin-bottom: 0.5rem;
                                cursor: pointer;
                              "
                              :style="{
                                transform: categoryFilter[item.id]
                                  ? 'rotate(180deg)'
                                  : 'none',
                              }"
                            />
                          </div>
                          <el-collapse-transition>
                            <div class="wm df" v-show="categoryFilter[item.id]">
                              <el-checkbox-group
                                v-model="params.categoryId"
                                class="wm"
                              >
                                <el-checkbox
                                  @change="
                                    handleCheckedCitiesChange($event, item2.id)
                                  "
                                  style="
                                    margin-top: 0.5rem;
                                    width: 100%;
                                    padding-left: 1rem;
                                  "
                                  v-for="(item2, index2) in item.children"
                                  :label="item2.id"
                                  :key="index2"
                                  >{{ item2.name }}</el-checkbox
                                >
                              </el-checkbox-group>
                            </div>
                          </el-collapse-transition>
                        </template>
                        <!-- <el-radio-group v-model="params.categoryId" @input="change">
									<el-radio :label="item.id" v-for="(item, index) in categories" :key="index"
										style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
								</el-radio-group> -->
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
                <div
                  v-if="brands.length"
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.7rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div
                      class="side-title"
                      @click="brandFilter = !brandFilter"
                      style="cursor: pointer"
                    >
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        >brand</span
                      >
                      <img
                        src="../../assets/imgs/arrow-down-black.png"
                        class="transition-normal"
                        style="
                          width: 0.8rem;
                          height: 0.4rem;
                          cursor: pointer;
                          margin-right: 1rem;
                        "
                        :style="{
                          transform: brandFilter ? 'rotate(180deg)' : 'none',
                        }"
                      />
                    </div>
                    <el-collapse-transition>
                      <div
                        class="side-content"
                        style="margin-top: 1rem"
                        v-if="brandFilter"
                      >
                        <el-checkbox-group
                          v-model="params.brandId"
                          @change="getdata"
                          class="wm"
                        >
                          <el-checkbox
                            v-for="(item, index) in brands"
                            :key="index"
                            style="margin-top: 0.5rem; width: 100%"
                            :value="item.id"
                            :label="item.id"
                            >{{ item.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                        <!-- <el-radio-group v-model="params.brandId">
									<el-radio :label="item.id" v-for="(item, index) in brands" :key="index"
										style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
								</el-radio-group> -->
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
                <div
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.7rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div
                      class="side-title"
                      @click="originFilter = !originFilter"
                      style="cursor: pointer"
                    >
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        >Origin</span
                      >
                      <img
                        src="../../assets/imgs/arrow-down-black.png"
                        class="transition-normal"
                        style="
                          width: 0.8rem;
                          height: 0.4rem;
                          cursor: pointer;
                          margin-right: 1rem;
                        "
                        :style="{
                          transform: originFilter ? 'rotate(180deg)' : 'none',
                        }"
                      />
                    </div>
                    <el-collapse-transition>
                      <div
                        class="side-content"
                        style="margin-top: 1rem; height: 30vh; overflow: scroll"
                        v-if="originFilter"
                      >
                        <el-select
                          v-model="params.countryId"
                          filterable
                          @change="getdata"
                          placeholder="choose origin"
                        >
                          <el-option
                            v-for="(item, index) in countrys"
                            :key="index"
                            :label="item.englishName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
                <div
                  v-if="authentications.length"
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.7rem 0;
                  "
                >
                  <div class="transition-normal">
                    <div
                      class="side-title"
                      @click="CertificationFilter = !CertificationFilter"
                      style="cursor: pointer"
                    >
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        >Certification</span
                      >
                      <img
                        src="../../assets/imgs/arrow-down-black.png"
                        class="transition-normal"
                        style="
                          width: 0.8rem;
                          height: 0.4rem;
                          cursor: pointer;
                          margin-right: 1rem;
                        "
                        :style="{
                          transform: CertificationFilter
                            ? 'rotate(180deg)'
                            : 'none',
                        }"
                      />
                    </div>
                    <el-collapse-transition>
                      <div
                        class="side-content"
                        style="margin-top: 1rem"
                        v-if="CertificationFilter"
                      >
                        <el-checkbox-group
                          v-model="params.authentications"
                          @change="getdata"
                          class="wm"
                        >
                          <el-checkbox
                            v-for="(item, index) in authentications"
                            :key="index"
                            style="margin-top: 0.5rem; width: 100%"
                            :value="item.id"
                            :label="item.id"
                            >{{ item.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                        <!-- <el-radio-group v-model="params.authentications">
									<el-radio :label="item.id" v-for="(item, index) in authentications" :key="index"
										style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
								</el-radio-group> -->
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
                <div
                  style="
                    margin: 0;
                    border-bottom: 1px solid #dddddd;
                    padding: 0.7rem 0;
                  "
                  v-if="propertiesList.length && showproPertiesFilter"
                  v-for="(item, index) in propertiesList"
                  :key="index"
                >
                  <div class="transition-normal">
                    <div
                      class="side-title"
                      @click="changePropertiesFilter(item)"
                      style="cursor: pointer"
                    >
                      <span
                        style="flex: 1; font-weight: bold; font-size: 0.9rem"
                        >{{ item.label }}</span
                      >
                      <img
                        src="../../assets/imgs/arrow-down-black.png"
                        class="transition-normal"
                        style="
                          width: 0.8rem;
                          height: 0.4rem;
                          cursor: pointer;
                          margin-right: 1rem;
                        "
                        :style="{
                          transform: propertiesFilter[item.id]
                            ? 'rotate(180deg)'
                            : 'none',
                        }"
                      />
                    </div>
                    <el-collapse-transition>
                      <div
                        class="side-content"
                        style="margin-top: 1rem"
                        v-if="propertiesFilter[item.id]"
                      >
                        <div class="df fdc">
                          <el-checkbox-group
                            v-model="properties[item.id]"
                            class="wm"
                          >
                            <el-checkbox
                              :key="index2"
                              v-for="(item2, index2) in item.property_values"
                              @change="
                                changeProperties($event, item.id, item2.id)
                              "
                              style="margin-top: 0.5rem; width: 100%"
                              :value="item2.id"
                              :label="item2.id"
                              >{{ item2.value }}</el-checkbox
                            >
                          </el-checkbox-group>
                          <!-- <el-radio-group v-model="properties[item.id]"
										@input="changeProperties($event,item.id)">
										<el-radio :label="item2.id" v-for="(item2, index) in item.property_values"
											:key="index"
											style="margin-top: 0.5rem;width: 100%;word-wrap: normal;">{{item2.value}}</el-radio>
									</el-radio-group> -->
                        </div>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
              </div>
              <div class="df jcc" style="margin: 1rem">
                <el-button @click="getdata" style="background-color: #22f7d3"
                  >Confirm</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="pro-list-mid">
          <el-drawer
            :visible.sync="showFilter"
            direction="ltr"
            :style="`width: ${isMobile ? 210 : 65}% !important;`"
          >
            <div
              slot="title"
              style="font-weight: bold; font-size: 1.5rem; color: #000"
            >
              Filter by
            </div>
            <div
              class="df fdc"
              style="height: 77vh; overflow-y: scroll; overflow-x: hidden"
            >
              <div
                style="
                  margin: 0 0.9rem;
                  border-top: 1px solid #dddddd;
                  border-bottom: 1px solid #dddddd;
                  padding: 0;
                "
              >
                <div class="transition-normal">
                  <div class="side-title" style="cursor: pointer">
                    <span
                      class="nwp"
                      style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >Recommended products</span
                    >
                    <el-checkbox
                      true-label="true"
                      false-label=""
                      style="
                        margin-top: 0.5rem;
                        width: 100%;
                        text-align: right;
                        padding-right: 0.5rem;
                      "
                      v-model="params.recommendedProducts"
                      label=""
                    ></el-checkbox>
                  </div>
                </div>
              </div>
              <div
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0;
                "
              >
                <div class="transition-normal">
                  <div class="side-title" style="cursor: pointer">
                    <span
                      class="nwp"
                      style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >Selected Products</span
                    >
                    <el-checkbox
                      true-label="true"
                      false-label=""
                      style="
                        margin-top: 0.5rem;
                        width: 100%;
                        text-align: right;
                        padding-right: 0.5rem;
                      "
                      v-model="params.selectedProducts"
                      label=""
                    ></el-checkbox>
                  </div>
                </div>
              </div>
              <div
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0;
                "
              >
                <div class="transition-normal">
                  <div class="side-title" style="cursor: pointer">
                    <span
                      class="nwp"
                      style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >New Products</span
                    >
                    <el-checkbox
                      true-label="true"
                      false-label=""
                      style="
                        margin-top: 0.5rem;
                        width: 100%;
                        text-align: right;
                        padding-right: 0.5rem;
                      "
                      v-model="params.newProducts"
                      label=""
                    ></el-checkbox>
                  </div>
                </div>
              </div>
              <div
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0.5rem 0;
                "
              >
                <div class="transition-normal">
                  <div
                    class="side-title"
                    @click="typeFilter = !typeFilter"
                    style="cursor: pointer"
                  >
                    <span style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >Type</span
                    >
                    <img
                      src="../../assets/imgs/arrow-down-black.png"
                      class="transition-normal"
                      style="width: 0.8rem; height: 0.4rem; margin-left: 0.5rem"
                      :style="{
                        transform: typeFilter ? 'rotate(180deg)' : 'none',
                      }"
                    />
                  </div>
                  <el-collapse-transition>
                    <div
                      class="side-content"
                      style="margin-top: 1rem"
                      v-show="typeFilter && showcategoryFilter"
                    >
                      <template
                        v-for="(item, index) in categories"
                        v-if="showType"
                      >
                        <div class="df jcsb aic wm">
                          <el-checkbox
                            :indeterminate="isIndeterminate"
                            :key="index"
                            v-model="category[item.id]"
                            @change="
                              handleCheckAllChange($event, item.id, index)
                            "
                            >{{ item.name }}</el-checkbox
                          >
                          <img
                            @click="changeCategory(item.id)"
                            v-if="item.children && item.children.length"
                            src="../../assets/imgs/arrow-down-black.png"
                            class="transition-normal"
                            style="
                              width: 0.8rem;
                              height: 0.4rem;
                              margin-left: 0.5rem;
                              margin-bottom: 0.5rem;
                              cursor: pointer;
                            "
                            :style="{
                              transform: categoryFilter[item.id]
                                ? 'rotate(180deg)'
                                : 'none',
                            }"
                          />
                        </div>
                        <el-collapse-transition>
                          <div class="wm df" v-show="categoryFilter[item.id]">
                            <el-checkbox-group
                              v-model="params.categoryId"
                              class="wm"
                            >
                              <el-checkbox
                                @change="
                                  handleCheckedCitiesChange($event, item2.id)
                                "
                                style="
                                  margin-top: 0.5rem;
                                  width: 100%;
                                  padding-left: 1rem;
                                "
                                v-for="(item2, index2) in item.children"
                                :label="item2.id"
                                >{{ item2.name }}</el-checkbox
                              >
                            </el-checkbox-group>
                          </div>
                        </el-collapse-transition>
                      </template>
                      <!-- <el-radio-group v-model="params.categoryId" @input="change">
										<el-radio :label="item.id" v-for="(item, index) in categories" :key="index"
											style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
									</el-radio-group> -->
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div
                v-if="brands.length"
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0.5rem 0;
                "
              >
                <div class="transition-normal">
                  <div
                    class="side-title"
                    @click="brandFilter = !brandFilter"
                    style="cursor: pointer"
                  >
                    <span style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >brand</span
                    >
                    <img
                      src="../../assets/imgs/arrow-down-black.png"
                      class="transition-normal"
                      style="
                        width: 0.8rem;
                        height: 0.4rem;
                        cursor: pointer;
                        margin-left: 0.5rem;
                      "
                      :style="{
                        transform: brandFilter ? 'rotate(180deg)' : 'none',
                      }"
                    />
                  </div>
                  <el-collapse-transition>
                    <div
                      class="side-content"
                      style="margin-top: 1rem"
                      v-if="brandFilter"
                    >
                      <el-checkbox-group v-model="params.brandId" class="wm">
                        <el-checkbox
                          v-for="(item, index) in brands"
                          :key="index"
                          style="margin-top: 0.5rem; width: 100%"
                          :value="item.id"
                          :label="item.id"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <!-- <el-radio-group v-model="params.brandId">
										<el-radio :label="item.id" v-for="(item, index) in brands" :key="index"
											style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
									</el-radio-group> -->
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0.5rem 0;
                "
              >
                <div class="transition-normal">
                  <div
                    class="side-title"
                    @click="originFilter = !originFilter"
                    style="cursor: pointer"
                  >
                    <span style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >Origin</span
                    >
                    <img
                      src="../../assets/imgs/arrow-down-black.png"
                      class="transition-normal"
                      style="
                        width: 0.8rem;
                        height: 0.4rem;
                        cursor: pointer;
                        margin-left: 0.5rem;
                      "
                      :style="{
                        transform: originFilter ? 'rotate(180deg)' : 'none',
                      }"
                    />
                  </div>
                  <el-collapse-transition>
                    <div
                      class="side-content"
                      style="margin-top: 1rem; height: 30vh; overflow: scroll"
                      v-if="originFilter"
                    >
                      <el-select
                        v-model="params.countryId"
                        filterable
                        placeholder="choose origin"
                      >
                        <el-option
                          v-for="(item, index) in countrys"
                          :key="index"
                          :label="item.englishName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div
                v-if="authentications.length"
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0.5rem 0;
                "
              >
                <div class="transition-normal">
                  <div
                    class="side-title"
                    @click="CertificationFilter = !CertificationFilter"
                    style="cursor: pointer"
                  >
                    <span style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >Certification</span
                    >
                    <img
                      src="../../assets/imgs/arrow-down-black.png"
                      class="transition-normal"
                      style="
                        width: 0.8rem;
                        height: 0.4rem;
                        cursor: pointer;
                        margin-left: 0.5rem;
                      "
                      :style="{
                        transform: CertificationFilter
                          ? 'rotate(180deg)'
                          : 'none',
                      }"
                    />
                  </div>
                  <el-collapse-transition>
                    <div
                      class="side-content"
                      style="margin-top: 1rem"
                      v-if="CertificationFilter"
                    >
                      <el-checkbox-group
                        v-model="params.authentications"
                        class="wm"
                      >
                        <el-checkbox
                          v-for="(item, index) in authentications"
                          :key="index"
                          style="margin-top: 0.5rem; width: 100%"
                          :value="item.id"
                          :label="item.id"
                          >{{ item.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <!-- <el-radio-group v-model="params.authentications">
										<el-radio :label="item.id" v-for="(item, index) in authentications" :key="index"
											style="margin-top: 0.5rem;width: 100%;">{{item.name}}</el-radio>
									</el-radio-group> -->
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div
                style="
                  margin: 0 0.9rem;
                  border-bottom: 1px solid #dddddd;
                  padding: 0.5rem 0;
                "
                v-if="propertiesList.length && showproPertiesFilter"
                v-for="(item, index) in propertiesList"
                :key="index"
              >
                <div class="transition-normal">
                  <div
                    class="side-title"
                    @click="changePropertiesFilter(item)"
                    style="cursor: pointer"
                  >
                    <span
                      style="flex: 1; font-weight: bold; font-size: 0.9rem"
                      >{{ item.label }}</span
                    >
                    <img
                      src="../../assets/imgs/arrow-down-black.png"
                      class="transition-normal"
                      style="
                        width: 0.8rem;
                        height: 0.4rem;
                        cursor: pointer;
                        margin-left: 0.5rem;
                      "
                      :style="{
                        transform: propertiesFilter[item.id]
                          ? 'rotate(180deg)'
                          : 'none',
                      }"
                    />
                  </div>
                  <el-collapse-transition>
                    <div
                      class="side-content"
                      style="margin-top: 1rem"
                      v-if="propertiesFilter[item.id]"
                    >
                      <div class="df fdc">
                        <el-checkbox-group
                          v-model="properties[item.id]"
                          class="wm"
                        >
                          <el-checkbox
                            :key="index2"
                            v-for="(item2, index2) in item.property_values"
                            @change="
                              changeProperties($event, item.id, item2.id)
                            "
                            style="margin-top: 0.5rem; width: 100%"
                            :value="item2.id"
                            :label="item2.id"
                            >{{ item2.value }}</el-checkbox
                          >
                        </el-checkbox-group>
                        <!-- <el-radio-group v-model="properties[item.id]"
											@input="changeProperties($event,item.id)">
											<el-radio :label="item2.id" v-for="(item2, index) in item.property_values"
												:key="index"
												style="margin-top: 0.5rem;width: 100%;word-wrap: normal;">{{item2.value}}</el-radio>
										</el-radio-group> -->
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
            <div class="df jcc" style="margin: 1rem">
              <el-button
                @click="mobileGetData"
                style="background-color: #22f7d3"
                >Confirm</el-button
              >
            </div>
          </el-drawer>
          <div class="main-box df jcsa fww" v-if="isMobile">
            <template v-for="(item, index1) in data">
              <productItem
                style="width: 48%"
                :col="null"
                :item="item"
                :key="index1"
              >
              </productItem>
              <productItem
                style="width: 48%; opacity: 0"
                :col="null"
                :item="item"
                v-if="index1 == data.length - 1 && data.length % 2 == 1"
              >
              </productItem>
            </template>
          </div>
          <div class="main-box row" :class="!isMobile ? 'custom' : ''" v-else>
            <productItem
              :col="isMobile ? 'col-6' : 'col-custom'"
              :item="item"
              v-for="(item, index1) in data"
              :key="index1"
            >
            </productItem>
          </div>
          <pagination
            :pageSizeList="[]"
            :page="params.page"
            :page-size="params.perPage"
            :total="nowtotal || 0"
            :on-page-change="onPage"
            class="pagi page-content"
          />
        </div>

        <!-- <div class="pro-list-right"></div> -->
      </div>
    </div>

    <Footer style="margin-top: 3rem"></Footer>
  </div>
</template>

<script>
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
import Pagination from "@/components/pagination.vue";
import Banner from "/src/components/product/banner.vue";
import productItem from "@/components/product/productItem.vue";
// import LeftFilter from './components/leftFilter.vue';
export default {
  data() {
    return {
      showType: true,
      isIndeterminate: false,
      topdata: [],
      sidedata: [],
      cid: "",
      typeFilter: true,
      brandFilter: false,
      originFilter: false,
      CertificationFilter: false,
      showproPertiesFilter: true,
      showcategoryFilter: true,
      origin: "",
      data: [],
      page: 1,
      perPage: 6,
      params: {
        providerId: null,
        brandId: [],
        categoryId: [],
        countryId: null,
        authentications: [],
        keyword: "",
        state: "true",
        status: 2,
        page: 1,
        perPage: 16,
        properties: "",
        recommendedProducts: "true",
        selectedProducts: "",
        newProducts: "",
      },
      sidebox: false,
      isMobile: false,
      islogin: false,

      total: 0,
      nowtotal: 0,
      showFilter: false,
      showLeftFilter: false,
      brands: [],
      countrys: [],
      categories: [],
      authentications: [],
      propertiesList: [],
      properties: {},
      category: {},
      propertiesFilter: {},
      categoryFilter: {},
    };
  },
  filters: {
    formatDate: function (timestemp) {
      let date = new Date(timestemp * 1000);
      return (
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      );
    },
  },
  components: {
    Header,
    Footer,
    Pagination,
    productItem,
    Banner,
    // LeftFilter
  },
  computed: {},
  created() {
    this.$bus.$emit("loading", true);
  },
  mounted() {
    this.isMobile = localStorage.getItem("isMobile") == "null" ? false : true;

    if (!this.$route.query.categoryId) this.getdata();
    this.getList();
  },
  methods: {
    async mobileGetData() {
      await this.getdata();
      this.showFilter = false;
    },
    changeCategory(id) {
      this.$set(this.categoryFilter, id, !this.categoryFilter[id]);
      this.showcategoryFilter = false;
      this.showcategoryFilter = true;
      console.log(this.categoryFilter);
    },
    handleCheckedCitiesChange(flag, id) {
      flag
        ? this.params.categoryId.includes(id)
          ? null
          : this.params.categoryId.push(id)
        : (this.params.categoryId = this.params.categoryId.filter(
            (v) => parseInt(v) != parseInt(id)
          ));
      console.log("this.params.categoryId", this.params.categoryId);
      this.categories.forEach((v) => {
        if (v.children.length) {
          if (
            v.children
              .map((v2) => v2.id)
              .some((v3) => this.params.categoryId.includes(v3))
          ) {
            this.category[v.id] = true;
            this.params.categoryId.includes(v.id)
              ? null
              : this.params.categoryId.push(v.id);
          } else if (
            v.children
              .map((v2) => v2.id)
              .every((v3) => !this.params.categoryId.includes(v3))
          ) {
            this.category[v.id] = false;
            this.params.categoryId = this.params.categoryId.filter(
              (v4) => v4 != v.id
            );
          }
        }
      });
      console.log(this.category);
      console.log(this.params.categoryId);
      this.change(this.params.categoryId.join(","));
    },
    handleCheckAllChange(flag, id, index) {
      let ids =
        this.categories[index].children &&
        this.categories[index].children.length
          ? this.categories[index].children.map((v) => v.id)
          : [];
      if (flag) {
        this.categoryFilter[id] = true;
        this.params.categoryId.push(id);
        this.params.categoryId = [...this.params.categoryId, ...ids];
        this.showType = false;
        this.showType = true;
      } else {
        this.params.categoryId = this.params.categoryId.filter((v) => {
          ids.push(parseInt(id));
          return !ids.includes(parseInt(v));
        });
      }

      console.log(this.params.categoryId);
      this.change(this.params.categoryId.join(","));
    },
    router(name) {
      if (!this.islogin) {
        if (this.isMobile) {
          this.$router.push({
            name: "mlogin",
            query: {
              type: 1,
            },
          });
        } else {
          localStorage.setItem("logintype", 1);
          this.$bus.$emit("login", true);
        }
      } else if (!this.isuserlevel && name != "customizeList") {
        this.$bus.$emit("userleveldialog", true);
      } else {
        this.$router.push({
          name,
        });
      }
    },
    changePropertiesFilter(item) {
      this.$set(
        this.propertiesFilter,
        item.id,
        !this.propertiesFilter[item.id]
      );
      this.showproPertiesFilter = false;
      this.showproPertiesFilter = true;
      console.log(this.propertiesFilter[item.id]);
    },
    changeProperties(flag, key, value) {
      // console.log(value, key);
      // this.$set(this.properties, key, value)
      this.showproPertiesFilter = false;
      this.showproPertiesFilter = true;
      // console.log(this.properties);
      if (!this.isMobile) {
        this.getdata();
      }
    },
    async change(categoryId) {
      if (categoryId) {
        let res = await this.$get(`/category/properties`, {
          categoryId,
        });
        this.propertiesList = res.data.properties;
        this.properties = {};
        this.propertiesList.forEach((v) => (this.properties[v.id] = []));
        this.propertiesList.forEach(
          (v) => (this.propertiesFilter[v.id] = false)
        );
        let res1 = await this.$get("/brands", {
          categoryId,
        });
        this.brands = res1.data.items;
        let res4 = await this.$get("/gci/authentication", {
          categoryId,
        });
        this.authentications = res4.data;
        if (!this.isMobile) {
          this.getdata();
        }
      }
    },
    async getList() {
      let res2 = await this.$get("/gci/country/list");
      this.countrys = res2.data.items;
      let res3 = await this.$get("/categories");
      this.categories = res3.data.items;
      this.categories.forEach((v) => {
        this.category[v.id] = false;
        this.categoryFilter[v.id] = false;
      });
      this.$bus.$emit("loading", false);
      if (this.$route.query.categoryId) {
        this.params.categoryId = [parseInt(this.$route.query.categoryId)];
        let id = this.params.categoryId.join(",");
        this.$nextTick(() => this.$set(this.category, id, true));
        let index = this.categories.findIndex(
          (v) => v.id == this.$route.query.categoryId
        );
        this.handleCheckAllChange(
          true,
          parseInt(this.$route.query.categoryId),
          index
        );
        await this.change(id);
        await this.getdata();
      }
    },
    tosearchmain(type) {
      this.$router.push({
        name: "searchmain",
        query: {
          type: type,
          keyword: this.searchkeyword,
        },
      });
    },
    // 分页
    onPage(pageNow) {
      if (!this.isuserlevel) return this.$bus.$emit("userleveldialog", true);
      this.params.page = pageNow;
      window.scrollTo(0, 0);
      this.getdata();
    },
    async getdata() {
      let properties = [];
      console.log(this.properties);
      for (let key in this.properties) {
        if (this.properties[key])
          properties = [...properties, ...this.properties[key]];
      }
      console.log(properties);
      let params = JSON.parse(JSON.stringify(this.params));
      if (properties.length) params.properties = properties.join(",");
      params.categoryId.length
        ? (params.categoryId = params.categoryId.join(","))
        : delete params.categoryId;
      params.brandId.length
        ? (params.brandId = params.brandId.join(","))
        : delete params.brandId;
      params.authentications.length
        ? (params.authentications = params.authentications.join(","))
        : delete params.authentications;
      let { data } = await this.$get("/gci/products", params);
      this.data = data.items;
      this.nowtotal = data.total;
      return;
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #32fcda;
  color: #32fcda;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #32fcda;
  color: #32fcda;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #32fcda;
}

/deep/ .el-checkbox__input + .el-checkbox__label {
  white-space: normal;
  /* 保留空白符序列，但是正常换行。*/
  // word-break: break-all;
  /* 允许在单词内部任意位置换行 */
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #000;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #ccc;
}

// /deep/ .el-drawer {
// 	width: 20% !important;
// }

::-webkit-scrollbar {
  width: 10px;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  background: #ccc; // 滑块颜色
  border-radius: 5px; // 滑块圆角
}

.side-box {
  background-color: #fff;
  border-radius: 1rem;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  padding: 0;
  height: 100%;

  .side-content {
    display: flex;
    flex-direction: column;
  }
}

.side-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  font-size: 1.2rem;
  align-items: center;
}

.side-content::-webkit-scrollbar {
  display: none;
}

.custom {
  margin: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &:after {
    content: "";
    flex: auto;
  }
}

.title-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: #333;
  font-size: 3rem;
}

.title-icon {
  width: 3rem;
  height: 3rem;
  margin-top: 1rem;
}

.top-bg {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/imgs/demand/bg.jpg");
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  flex-direction: column;
  height: 575px;
}

.search-box {
  width: 30rem;
  height: 2.5rem;
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 5rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  border: 1px solid #ececec;
}

.filter-box {
  height: 2.5rem;
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 5rem;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ececec;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;

  &:hover {
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
    transition: all 0.2s linear;
  }
}

.supplier-desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.box-border {
  width: 25rem;
}

@media (max-width: 767px) {
  .box-border {
    width: 19rem;
  }

  .side-box {
    position: fixed;
    left: 0;
    top: 4rem;
    z-index: 9;
    height: 100%;
    border-radius: 0;
    padding-top: 5rem;
  }

  .top-bg {
    padding-top: 7rem !important;

    // position:fixed;z-index:10;left:0;top:0;
    .search-box {
      display: none;
    }
  }

  .top {
    flex-direction: column;
    align-items: flex-start;
  }

  .top-title {
    font-size: 1.5rem;
  }

  .top1 {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .top2 {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .main-box {
    padding-top: 1rem;
    // padding: 0.5rem !important;
    // flex-direction: column !important;
    // align-items: flex-start !important;
    // padding-left: 0 !important;
  }

  .search-box {
    width: 100%;
  }

  .col-9 {
    width: 100%;
    min-width: 100%;
  }

  .main-title {
    font-size: 1.2rem;
  }

  .title-box {
    font-size: 2.2rem;
  }

  .title-icon {
    margin-top: 0.5rem;
  }

  .row {
    margin-top: 0 !important;
  }

  .box1 {
    width: 100%;
  }
}

@media (min-width: 767px) {
  .main-box {
    margin-bottom: 1rem;
  }

  .top-bg {
    padding-bottom: 3rem;
  }
}

/* Normal desktop :1200px. */
@media (min-width: 1200px) {
  .new-container {
    max-width: 1500px;
  }
}

.flex-wrap {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .pro-list-left {
    width: 15.6rem;

    .wrap-pdr05 {
      padding-right: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  .pro-list-right {
    width: 10rem;
    height: 1px;
  }

  .pro-list-mid {
    // max-width: 63rem;
    flex: 1;
  }
}

.wrap {
  padding-right: 1rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.nwp {
  white-space: nowrap;
}
</style>
